import * as React from "react";

const Loader = React.memo(({ text = '', imageUrl = './images/logo.png' }) => (
    <div className="main-div">
        <div className='position-relative text-center'>
            {/* Rotating Spinner Background */}
            <div className="spinner-border text-danger mt-3" role="status" style={{
                width: '100px',
                height: '100px',
                position: 'relative'
            }}>
                <span className="visually-hidden">Loading...</span>
            </div>

            {/* Logo on top of spinner */}
            <img
                src={imageUrl}
                loading='eager'
                alt='Loading...'
                className="position-absolute top-50 start-50 translate-middle"
                style={{
                    width: '120px',
                    height: '120px',
                    objectFit: 'contain',
                    borderRadius: '50%'
                }}
            />
            <h2 className="text-center mt-4">{text}</h2>
        </div>
    </div>
));

export default Loader;